/* ============================================================
   VikingsBrand — collection.personalized rune demo
   ("Type a name — see it in runes").

   Client-side only, no cart involvement — a confidence tool, not a
   form (per the handoff). State: text (default "Ragnar", max 20
   chars) + script ("Latin" | one of the three futharks, default Elder
   — lead with the runes, that's the hook). Empty input renders "—".

   Transliteration comes from window.VBRunes (assets/vb-runes.js)
   — the same shared map the product.blade engraving configurator
   uses, so the two can never drift apart.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.pzInit === 'true') return;
    root.dataset.pzInit = 'true';

    var input = root.querySelector('[data-pz-demo-input]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-pz-demo-script]'));
    var label = root.querySelector('[data-pz-demo-script-label]');
    var preview = root.querySelector('[data-pz-demo-preview]');
    if (!input || !preview) return;

    /* Limit comes off the input's maxlength, never a literal. */
    var maxLen = parseInt(input.getAttribute('maxlength'), 10) || 60;
    var state = {
      text: (input.value || '').slice(0, maxLen),
      script: 'Elder Futhark'
    };
    var pressed = chips.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
    if (pressed) state.script = pressed.dataset.value;

    function render() {
      var t = state.text.trim();
      /* Same map keys as the two cart widgets; Latin resolves to no key. */
      var runeKey = { 'Elder Futhark': 'elder', 'Younger Futhark': 'younger', 'Anglo-Saxon': 'anglo' }[state.script] || null;
      var runic = !!runeKey;
      chips.forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.value === state.script ? 'true' : 'false');
      });
      if (label) label.textContent = state.script;
      preview.classList.toggle('vb-pz-demo__previewtext--runic', runic);
      if (!t) {
        preview.textContent = '—';
        return;
      }
      preview.textContent = (runic && window.VBRunes) ? window.VBRunes.transliterate(t, runeKey) : t.toUpperCase();
    }

    input.addEventListener('input', function () {
      if (input.value.length > maxLen) input.value = input.value.slice(0, maxLen);
      state.text = input.value;
      render();
    });

    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        state.script = b.dataset.value;
        render();
      });
    });

    render();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-pz-demo]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: re-init when the section is re-rendered */
  document.addEventListener('shopify:section:load', boot);
})();
